import { createGlobalStyle } from "styled-components/macro";
import { TTheme } from "./defaultTheme";

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }: { theme: TTheme }) => theme.colors.gray10};
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.gray100};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;

    *, *:before, *:after {
      box-sizing: border-box;
      transition-duration: 0.25s;
      transition-timing-function: ease-in-out;
      transition-property: color, background-color, padding, border-color, border-width, box-shadow, stroke, fill;
    }

    a {
      color: ${({ theme }) => theme.colors.primary100};
      font-weight: 700;

      &:hover {
        color: ${({ theme }) => theme.colors.gray100};
        text-decoration: none;
      }

      &:active {
        text-decoration: underline;
      }
    }
  }
`;
